import { Box, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

const PRIMARY = '#D02964';

const BookingSuccessScreen = () => {
  const navigate = useNavigate();
  const { t } = useIntlTranslations('bookingSuccessScreen');
  return (
    <Box textAlign="center" py={6} px={2}>
      <CheckCircleIcon sx={{ fontSize: 72, color: PRIMARY, mb: 2 }} />
      <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 1 }}>
        {t('title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, whiteSpace: 'pre-line' }}>
        {t('subtitle')}
      </Typography>
      <Button
        variant="outlined"
        sx={{ borderColor: PRIMARY, color: PRIMARY, borderRadius: '12px' }}
        onClick={() => navigate('..', { relative: 'path' })}
      >
        {t('backButton')}
      </Button>
    </Box>
  );
};

export default BookingSuccessScreen;
